import React from 'react';
import { ReactComponent as Behance } from 'dist/icons/socialNetworks/Behance.svg';
import { ReactComponent as Dribbble } from 'dist/icons/socialNetworks/Dribbble.svg';
import { ReactComponent as Email } from 'dist/icons/socialNetworks/Email.svg';
import { ReactComponent as Facebook } from 'dist/icons/socialNetworks/Facebook.svg';
import { ReactComponent as GitHub } from 'dist/icons/socialNetworks/Github.svg';
import { ReactComponent as Gitlab } from 'dist/icons/socialNetworks/Gitlab.svg';
import { ReactComponent as VK } from 'dist/icons/socialNetworks/VK.svg';
import { ReactComponent as Instagram } from 'dist/icons/socialNetworks/Instagram.svg';
import { ReactComponent as LinkIcon } from 'dist/icons/socialNetworks/Link.svg';
import { ReactComponent as LinkedIn } from 'dist/icons/socialNetworks/Linkedin.svg';
import { ReactComponent as Phone } from 'dist/icons/socialNetworks/Phone.svg';
import { ReactComponent as StackOverflow } from 'dist/icons/socialNetworks/StackOverflow.svg';
import { ReactComponent as Telegram } from 'dist/icons/socialNetworks/Telegram.svg';
import { ReactComponent as X } from 'dist/icons/socialNetworks/X.svg';
import type { IconProps } from './types';

export const Icon: React.FC<IconProps> = ({ type, ...props }) => {
  switch (type) {
    case 'Behance':
      return <Behance {...props} />;
    case 'Dribbble':
      return <Dribbble {...props} />;
    case 'Email':
      return <Email {...props} />;
    case 'Facebook':
      return <Facebook {...props} />;
    case 'GitHub':
      return <GitHub {...props} />;
    case 'Gitlab':
      return <Gitlab {...props} />;
    case 'VK':
      return <VK {...props} />;
    case 'Instagram':
      return <Instagram {...props} />;
    case 'Link':
      return <LinkIcon {...props} />;
    case 'LinkedIn':
      return <LinkedIn {...props} />;
    case 'Phone':
      return <Phone {...props} />;
    case 'StackOverflow':
      return <StackOverflow {...props} />;
    case 'Telegram':
      return <Telegram {...props} />;
    case 'Twitter':
      return <X {...props} />;
    default:
      return <LinkIcon {...props} />;
  }
};
